import { memo } from 'react';
import clsx from 'clsx';
import { ComponentMemo } from '@headless-workspace/typings';
import { AdvancedCardProps, CardStyle, CardType, ComposableCard } from '../../newComposables';

export const GlowAdvancedCard: ComponentMemo<AdvancedCardProps> = memo(
    ({ children, image, className, content, direction, ...props }) => {
        return (
            <ComposableCard.Root type={CardType.CardAdvanced} direction={direction} {...props}>
                <ComposableCard.SelectableContainer
                    className={clsx(
                        props.isDisabled ? CardStyle.isDisabled : CardStyle.backgroundTile({ ...props }),
                        className,
                    )}
                    {...props}
                >
                    <ComposableCard.Image {...image} />
                    <ComposableCard.Content hasImage={!!image} {...content}>
                        {children}
                    </ComposableCard.Content>
                </ComposableCard.SelectableContainer>
            </ComposableCard.Root>
        );
    },
);

GlowAdvancedCard.displayName = 'GlowAdvancedCard';
